export default "__VITE_ASSET__BjfQypz4__"